/*jshint esversion: 11 */
import React, { useEffect, useState } from 'react';
import {
  Row,
  Col,
  Button,
  FormGroup,
  Label,
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Input
} from 'reactstrap';
import { connect } from 'react-redux';
import PageDataLoader from '../Utility/PageDataLoader';
import { fetchImage } from '../../api/image';

const ViewCircularModal = ({
  modalOpenState,
  closeModalHandler,
  circularInfoLoading,
  circularInfo
}) => {
  const [fileUrls, setFileUrls] = useState({});

  useEffect(() => {
    async function loadFileUrls() {
      if (!circularInfo?.files?.length) return;

      const urls = {};

      for (const f of circularInfo.files) {
        const url = await fetchImage(f.documentKey);
        if (url) {
          urls[f.documentKey] = url;
        }
      }

      setFileUrls(urls);
    }

    loadFileUrls();
  }, [circularInfo]);

  return (
    <React.Fragment>
      <Modal isOpen={modalOpenState} backdrop="static" size="lg">
        <ModalHeader toggle={closeModalHandler}>
          {circularInfoLoading ? 'Loading ...' : circularInfo?.name}
        </ModalHeader>
        <ModalBody>
          {circularInfoLoading ? (
            <div className="d-flex justify-content-center">
              <PageDataLoader />
            </div>
          ) : (
            <React.Fragment>
              <Row>
                <Col md="12">
                  <FormGroup>
                    <Label>Description</Label>
                    <Input
                      type="text"
                      value={circularInfo?.description || '-'}
                      readOnly
                    />
                  </FormGroup>
                </Col>
                <Col md="12">
                  <FormGroup>
                    <Label>Tag</Label>
                    <Input
                      type="text"
                      value={circularInfo?.tag?.name || '-'}
                      readOnly
                    />
                  </FormGroup>
                </Col>
                <Col md="12">
                  <FormGroup>
                    <Label>Batches</Label>
                    <Input
                      type="textarea"
                      value={
                        circularInfo?.batches?.length
                          ? circularInfo.batches.map((b) => b.name).join(', ')
                          : '-'
                      }
                      readOnly
                    />
                  </FormGroup>
                </Col>

                {/* FILE IDS */}
                <Col md="12">
                  <FormGroup>
                    <Label>Files</Label>

                    {circularInfo?.files?.length ? (
                      circularInfo.files.map((f, index) => {
                        const url = fileUrls[f.documentKey];

                        return (
                          <div key={index} style={{ marginBottom: '15px' }}>
                            {url ? (
                              <>
                                <iframe
                                  src={`https://docs.google.com/gview?url=${encodeURIComponent(url)}&embedded=true`}
                                  width="100%"
                                  height="400px"
                                  style={{
                                    border: '1px solid #ccc',
                                    borderRadius: '6px'
                                  }}
                                />
                              </>
                            ) : (
                              <p>Loading...</p>
                            )}
                          </div>
                        );
                      })
                    ) : (
                      <Input type="text" value="-" readOnly />
                    )}
                  </FormGroup>
                </Col>
              </Row>

              <ModalFooter>
                <Button type="button" color="light" onClick={closeModalHandler}>
                  Close
                </Button>
              </ModalFooter>
            </React.Fragment>
          )}
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    authUser: state.Login?.user
  };
};

export default connect(mapStateToProps)(ViewCircularModal);
